import React from 'react';
import { AGENCY_REGISTRATION_APPLICATION_STATUS } from '../utilities/constants';
import { getAgencyRegistrationApplicationStatus } from '../utilities/constantsUtil';

const Status = props => {
  const { status } = props;
  const statusClassName = status => {
    switch (status) {
      case AGENCY_REGISTRATION_APPLICATION_STATUS.NOT_APPLIED.ID:
        return `AgencyStatus AgencyStatus--not-applied`;
      case AGENCY_REGISTRATION_APPLICATION_STATUS.REJECTED.ID:
        return `AgencyStatus AgencyStatus--rejected`;
      default:
        return `AgencyStatus`;
    }
  };
  return (
    <div className={statusClassName(status)}>
      {getAgencyRegistrationApplicationStatus(status) || '-'}
    </div>
  );
};

export default Status;



// WEBPACK FOOTER //
// ./src/components/AgencyRegistrationApplicationStatus.jsx